"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSharedContactOne = void 0;
const date_1 = require("../utils/date");
const organization_1 = require("./organization");
const utils_1 = require("../utils");
const organization = (0, organization_1.mockChildOrganization)();
const base = Object.assign({ id: 100000, organization_id: organization.id, first_name: 'Contact', last_name: 'One', emails: [], phones: [], data: {}, __lists: [], anonymized_at: null, last_communication_at: '' }, date_1.mockDateObject);
exports.mockSharedContactOne = (0, utils_1.mockFunction)(Object.assign({}, base));
